import React from 'react';
import AppImages from '../assets/appImages1.webp';
import Repair from '../assets/repair.webp';
import '../App.css';

const step2Header = "Tenant Activation";
const step2 = "Tenants and residents can quickly and conveniently activate chargers through the Gridspot app, enabling them to start charging their vehicles in seconds. With an intuitive and user-friendly interface, the app guides users step-by-step, making setup and activation a breeze. Gridspot’s app seamlessly handles everything from account creation and payment processing to ongoing support. By offering a reliable and streamlined charging experience, we ensure that residents can focus on what matters most—charging their vehicles without any hassle.";
const step3Header = "Ongoing Maintenance & Support";
const step3 = "At Gridspot, we handle everything to keep your EV chargers running smoothly. From routine maintenance and necessary repairs to software and hardware upgrades, our team ensures that every charger performs at its best. Property managers can enjoy peace of mind knowing that Gridspot continuously monitors each unit to detect and address any issues proactively, maximizing reliability and minimizing downtime. With our comprehensive support, you don’t need to worry about upkeep—just let us take care of the details, so your tenants and residents can count on a seamless charging experience every time.";

export default function MgSvcSteps() {
  return (
    <>
      <section className="section">
        <div className="container split">
          <div>
            <h2>{step2Header}</h2>
            <p className="lead">{step2}</p>
          </div>
          <img className="split-phones" src={AppImages} alt="Gridspot app showing a charger map and the login screen" loading="lazy" width="900" height="1260"/>
        </div>
      </section>
      <section className="section section-tint">
        <div className="container split split-reverse">
          <div>
            <h2>{step3Header}</h2>
            <p className="lead">{step3}</p>
          </div>
          <img className="split-photo" src={Repair} alt="Technician testing a charger circuit board with a multimeter" loading="lazy" width="1000" height="568"/>
        </div>
      </section>
    </>
  )
}
